import { Helmet } from 'react-helmet';
import { Outlet } from 'react-router-dom';
import useBodyClass from '../common/hooks/useBodyClass';
import './App.scss';

function App() {
    useBodyClass(['mdc-typography', 'onlive-channel-subscription']);
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Onlive.site Subscription</title>
                <link
                    href="https://fonts.googleapis.com/css?family=Montserrat:100,300,400,500,700,900"
                    rel="stylesheet"
                />
            </Helmet>
            <Outlet />
        </>
    );
}

export default App;
